import { ReactNode } from "react";
import styled, { createGlobalStyle } from "styled-components";

/** The `TasksSpacer` component properties. */
export interface TasksSpacerProps {

  /** The component children. */
  readonly children: ReactNode;
}

/** The tasks spacer root. */
const TasksSpacerRoot = styled.div`
  
`;

/** The tasks spacer globals. */
const TasksSpacerGlobals = createGlobalStyle`
  body.has-tasks {
    ${TasksSpacerRoot} {
      padding-bottom: calc(1rem + 52px);
    }
  }
`;

/** Component which applies padding to its bottom to account for the tasks flyout visibility. */
export const TasksSpacer = (props: TasksSpacerProps): ReactNode => {
  const { children } = props;

  return (
    <>
      <TasksSpacerGlobals />
      <TasksSpacerRoot>
        {children}
      </TasksSpacerRoot>
    </>
  );
};
